import PropTypes from "prop-types";
export var themeConfigPropTypes = {
  name: PropTypes.string.isRequired,
  prefix: PropTypes.string,
  rootStyle: PropTypes.objectOf(PropTypes.string.isRequired),
  dropTarget: PropTypes.string
};
export var themeConfigShape = PropTypes.shape(themeConfigPropTypes);